import type { SVGProps } from 'react';

const SvgMetadataDropdown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 6H6C4.35 6 3 7.35 3 9v6c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V9c0-1.65-1.35-3-3-3m1 9c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M15.29 10.29 14 11.58l-1.29-1.29a.996.996 0 1 0-1.41 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29l2-2a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgMetadataDropdown;
